import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import css from '~/features/dashboard/components/song-details/styles.module.scss';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import { Search } from '~/common/search';
import { Pagination } from '@material-ui/lab';

interface dspData_props {
    DSP: string;
    ISRC: string;
    artistid: string;
    creativeName: string;
    meta: string;
    projectName: string;
    songRef: string;
    songURL: string;
    sourceId: string;
    trackId: string;
    trackname: string;
}

interface DSPGridProps {
    dsp: dspData_props[];
    projectId: any;
    changeToggleDrawer: (event: any) => void;
    drawerTitle: any;
}

function dspSwitch(props: any) {
    switch (Number(props.DSP)) {
        case 1:
            const spotify = JSON.parse(props.albumMeta).images[0].url;
            return <CardMedia style={{ height: '140px' }} image={spotify} title={props.creativeName} />;
        case 2:
            const apple = JSON.parse(props.albumMeta);
            let width = /{w}/gi;
            let height = /{h}/gi;
            let image = apple.attributes.artwork.url.replace(width, 140).replace(height, 140);
            return <CardMedia style={{ height: '140px' }} image={image} title={props.creativeName} />;
        case 3:
            const youtube = JSON.parse(props.meta).snippet;
            return <CardMedia style={{ height: '140px' }} image={youtube.thumbnails.medium.url} title={props.creativeName} />;
        default:
            return (
                <CardMedia style={{ height: '140px', textAlign: 'center', backgroundColor: '#daebec' }}>
                    <MusicNoteIcon style={{ height: '140px', width: '30%', fill: '#6cb9b7' }} />
                </CardMedia>
            );
    }
}

export const DSPTab: React.FC<DSPGridProps> = ({ dsp, changeToggleDrawer, drawerTitle }) => {
    const [searchValue, setSearchValue] = useState('');
    const [filterDSP, setFilterDSP] = useState<dspData_props[]>([]);

    // pagination DSP
    const [currentPage, setCurrentPage] = useState(1);
    const [PerPage] = useState(9);

    // Get current DSP
    const indexOfLast = currentPage * PerPage;
    const indexOfFirst = indexOfLast - PerPage;
    const current = filterDSP.slice(indexOfFirst, indexOfLast);
    const page = Math.ceil(filterDSP.length / PerPage);

    useEffect(() => {
        setFilterDSP(
            dsp.filter(
                dspFill =>
                    dspFill.creativeName.toLowerCase().includes(searchValue.toLowerCase()) ||
                    dspFill.trackname.toLowerCase().includes(searchValue.toLowerCase())
            )
        );
    }, [dsp, searchValue]);
    return (
        <div className="">
            <div className="">
                <div className="" style={{ display: 'flex', borderBottom: '1px solid #ccc', padding: '10px 0px 10px 24px', verticalAlign: 'center' }}>
                    <ArrowBackIcon style={{ verticalAlign: 'center', lineHeight: '10px', cursor: 'pointer' }} onClick={() => changeToggleDrawer(false)} />
                    <Typography
                        variant={'h6'}
                        className={css.drawertitle}
                        onClick={() => changeToggleDrawer(false)}
                        style={{ lineHeight: '25px', cursor: 'pointer', marginLeft: '0.5rem' }}
                    >
                        Close
                    </Typography>
                </div>
                <div className={css.header} style={{ padding: '24px' }}>
                    <Typography variant={'h6'} className={css.drawertitle}>
                        {drawerTitle}
                    </Typography>
                    <Search search={searchValue} onSearchChange={setSearchValue} className={css.search} />
                </div>
            </div>
            <div className={css.dspCardbox}>
                {current &&
                    current.map(item => (
                        <Card className={css.dspCard}>
                            <CardActionArea>
                                {dspSwitch(item)}
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        {item.creativeName}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {item.trackname}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
            </div>
            {page > 1 && (
                <Pagination
                    className={css.paginationDSP}
                    count={page}
                    page={currentPage}
                    onChange={(event: any, value: any) => {
                        setCurrentPage(value);
                    }}
                    variant="outlined"
                    shape="rounded"
                    hideNextButton
                    hidePrevButton
                />
            )}
        </div>
    );
};
